export const CSR_ORDERS_SET_DATA_BEGIN = 'CSR_ORDERS_SET_DATA_BEGIN';
export const CSR_ORDERS_SET_DATA_SUCCESS = 'CSR_ORDERS_SET_DATA_SUCCESS';
export const CSR_ORDERS_SET_DATA_FAIL = 'CSR_ORDERS_SET_DATA_FAIL';
export const GET_ON_BEHALF_USER_INFO_BEGIN = 'GET_ON_BEHALF_USER_INFO_BEGIN';
export const GET_ON_BEHALF_USER_INFO_SUCCESS =
  'GET_ON_BEHALF_USER_INFO_SUCCESS';
export const GET_ON_BEHALF_USER_INFO_FAIL = 'GET_ON_BEHALF_USER_INFO_FAIL';
